
      import ArrowRadius from './arrow-radius.vue'
      import type { App, Plugin } from 'vue'

      export const ArrowRadiusPlugin: Plugin = {
        install(app: App) {
          app.component('ArrowRadius', ArrowRadius)
        },
      }
      export { ArrowRadius }
      